/* eslint-disable no-extra-boolean-cast */
import React from 'react'
import { Icon, Button, Header, Label, Table, Rating, Divider, Popup, Modal } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import _ from 'lodash'
// eslint-disable-next-line import/no-unresolved
import QRcode from 'qrcode.react'
import CryptoJS from 'crypto-js'
import firebase from '../../../config/firebase'

import StorePlaceholder from './storePlaceholder'
import TagsRearrange from '../fields/tagsRearrangeField'
import LogoField from '../fields/logoField'
import BannerField from '../fields/bannerField'
import VendorInfoButton from './vendorInfoButton'
import VendorInfoForm from '../forms/vendorInfoForm'

export default class StoreSummary extends React.PureComponent {
  state = {
    visibleQrCode: false,
    editable: false,
    changingRegion: false,
    destinationRegion: null,
    vendorInfoModalVisible: false,
  }

  onRateChange = (e, { rating }) => {
    const { storeId } = this.props

    const updates = {}

    updates[`/restaurants/${storeId}/rate`] = rating

    firebase
      .database()
      .ref()
      .update(updates)
  }

  onEditableClick = () => {
    const { editable } = this.state

    if (!editable) {
      this.setState({ editable: true })
    } else {
      this.setState({ editable: false })
    }
  }

  onRegionChange = async regionId => {
    const { storeId, history, user, store } = this.props
    const updates = {}

    updates[`/restaurants/${storeId}/region`] = regionId
    updates[`/restaurants/${storeId}/categories/${user.region}`] = null
    updates[`/restaurants/${storeId}/categories/${regionId}`] = store.categories ? store.categories[user.region] : null

    this.setState({
      changingRegion: true,
      destinationRegion: regionId
    })

    await firebase.database().ref().update(updates)

    history.push('/restaurants')
  }

  renderLoading = () => <StorePlaceholder />

  renderCategories = () => {
    const { menus, store } = this.props

    const categoryKeys = Object.keys(store.categories || {})

    const categories = []

    _.forEach(menus, menu => {
      _.forEach(menu.categories, (category, key) => {
        if (_.includes(categoryKeys, key)) categories.push(category.name)
      })
    })

    return categories.map(catName => <Label key={catName}>{catName}</Label>)
  }

  renderTags = () => {
    const { tags, store, storeId } = this.props
    const { editable } = this.state

    if (_.size(store.tags) > 0) {
      if (!editable) {
        let tagsToShow = _.map(store.tags || {}, (tag, tagKey) => ({ ...tag, tagKey }))
        tagsToShow = _.orderBy(tagsToShow, ['listing_number'], ['asc'])

        return (
          <div>
            {_.map(tagsToShow, tag => (
              <Label style={{ marginBottom: 3 }} key={tag.tagKey}>
                {tags[tag.tagKey] || '...'}
              </Label>
            ))}
            <div>
              <Label
                onClick={this.onEditableClick}
                color="black"
                style={{ marginTop: 10, cursor: 'pointer' }}
              >
                Rearrange
              </Label>
            </div>
          </div>
        )
      }

      return (
        <TagsRearrange
          storeTags={store.tags || {}}
          allTags={tags}
          storeId={storeId}
          setEditable={this.onEditableClick}
        />
      )
    }

    return null
  }

  renderTierColor = tier => {
    if (tier === 1) {
      return 'green'
    }

    return 'orange'
  }

  renderChangeRegionButton = () => {
    const { regions, user } = this.props
    const { destinationRegion, changingRegion } = this.state
    const displayRegions = regions.filter(region => region.id !== user.region)

    return (
      <Popup
        on='click'
        trigger={
          <Button icon color="black">
            <Icon name="globe" /> Change Region
          </Button>
        }
        position="bottom center"
        style={{ width: 190 }}
      >
        {
          displayRegions.map(region => (
            <Button
              key={region.id}
              style={{ width: 170, marginBottom: 5 }}
              onClick={() => this.onRegionChange(region.id)}
              loading={changingRegion && destinationRegion === region.id}
              disabled={changingRegion}
            >
              {region.name}
            </Button>
          ))
        }
      </Popup>
    )
  }

  downloadQRCode = () => {
    const { store } = this.props

    const canvas = document.getElementById("qr-code");
    const pngUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");

    const downloadLink = document.createElement("a");

    downloadLink.href = pngUrl;
    downloadLink.download = `${store.name}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    this.setState({ visibleQrCode: false })
  };

  renderGenerateQRCodeButton = () => {
    const { visibleQrCode } = this.state
    const { store, eMenuConfigs } = this.props

    const imageSetting = {
      src: require("../../../assets/images/muuve_logo.png"),
      height: 50,
      width: 50,
    }

    const encryptedStoreId = CryptoJS.AES.encrypt(store.key, eMenuConfigs.encrypt_key).toString();
    const qrCodeValue = `${eMenuConfigs.url}?key=${encryptedStoreId}`

    return (
      <Modal
        onOpen={() => this.setState({ visibleQrCode: true })}
        open={visibleQrCode}
        style={{ marginTop: 0 }}
        trigger={
          <Button icon color="black">
            <Icon name="qrcode" /> Generate QR Code
          </Button>
        }
      >
        <Modal.Header>QR Code</Modal.Header>
        <Modal.Content style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <QRcode
            id="qr-code"
            value={qrCodeValue}
            renderAs="canvas"
            level="H"
            size={300}
            imageSettings={imageSetting}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.setState({ visibleQrCode: false })}>
            Close
          </Button>
          <Button icon color='black' onClick={this.downloadQRCode}>
            <Icon name="download" /> Download
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }

  renderSummary = () => {
    const { store, storeId, fetchStore, eMenuConfigs } = this.props
    const { vendorInfoModalVisible } = this.state

    const merchantName = store.reference_merchant_id ? `${store.name} (${store.reference_merchant_id})` : store.name

    return (
      <Table className="no-border" style={{ fontSize: 16 }}>
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan={3} style={{ padding: 0, paddingLeft: 14 }}>
              <Header>Images</Header>
            </Table.Cell>
            <Table.Cell textAlign="right" style={{ padding: 0, paddingRight: 14 }}>
              {eMenuConfigs && this.renderGenerateQRCodeButton()}
              {this.renderChangeRegionButton()}
              <Link to={`/restaurants/${storeId}/edit`}>
                <Button icon color="black">
                  <Icon name="edit" /> Edit
                </Button>
              </Link>
            </Table.Cell>
          </Table.Row>
          <Table.Row verticalAlign="top">
            <Table.Cell>
              <div>
                <div>
                  <strong>Logo</strong>
                </div>
                <div style={{ marginTop: 10 }}>
                  <LogoField storeId={storeId} store={store} fetchStore={fetchStore} />
                </div>
              </div>
            </Table.Cell>
            <Table.Cell />
            <Table.Cell>
              <div>
                <div>
                  <strong>Banner (640x360)</strong>
                </div>
                <div style={{ marginTop: 10 }}>
                  <BannerField storeId={storeId} store={store} fetchStore={fetchStore} />
                </div>
              </div>
            </Table.Cell>
            <Table.Cell />
          </Table.Row>
          <Table.Row verticalAlign="top">
            <Table.Cell colSpan={4}>
              <Divider />
              <Header>Summary</Header>
            </Table.Cell>
          </Table.Row>
          <Table.Row verticalAlign="top">
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Name:</Table.Cell>
            <Table.Cell style={{ width: '35%', fontWeight: 'bold' }}>{merchantName}</Table.Cell>
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Preparation Time:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>
              {store.cooking_duration && `${parseInt(store.cooking_duration, 10)} min`}
            </Table.Cell>
          </Table.Row>
          <Table.Row verticalAlign="top">
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Rating:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>
              <Rating defaultRating={store.rate} maxRating={5} onRate={this.onRateChange} />
            </Table.Cell>
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Status:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>
              {store.status && (
                <Label color={store.status === 'publish' ? 'green' : 'red'} horizontal>
                  {_.capitalize(store.status)}
                </Label>
              )}
              {store.tier > 0 ? (
                <Label horizontal color={this.renderTierColor(store.tier)}>
                  Tier {store.tier}
                </Label>
              ) : null}
            </Table.Cell>
          </Table.Row>
          <Table.Row verticalAlign="top">
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Categories:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>{this.renderCategories()}</Table.Cell>
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Commission rate:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>{store.discount_rate || 0}%</Table.Cell>
          </Table.Row>
          <Table.Row verticalAlign="top">
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Tags:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>{this.renderTags()}</Table.Cell>
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>VAT:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>{store.vat || 0}%</Table.Cell>
          </Table.Row>
          <Table.Row verticalAlign="top">
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Restricted Age:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>{Boolean(store.restricted_age) ? "Yes" : "No"}</Table.Cell>
            <Table.Cell style={{ width: '15%', fontWeight: 'bold', paddingTop: 15 }}>Vendor Info:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>
              <VendorInfoButton
                vendorData={store}
                onClick={() => this.setState({ vendorInfoModalVisible: true })}
              />
            </Table.Cell>
            {
              store && (
                <VendorInfoForm
                  storeId={store.key}
                  vendorData={store}
                  visible={vendorInfoModalVisible}
                  onClose={() => this.setState({ vendorInfoModalVisible: false })}
                />
              )
            }
          </Table.Row>
          <Table.Row verticalAlign="top">
            <Table.Cell style={{ width: '15%', fontWeight: 'bold' }}>Mark Up Percentage:</Table.Cell>
            <Table.Cell style={{ width: '35%' }}>{store.mark_up_percentage || 0}%</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    )
  }

  render() {
    const { store, loading } = this.props

    if (loading || !store) {
      return this.renderLoading()
    }

    if (store) {
      return this.renderSummary()
    }

    return null
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/views/storeSummary.js